'use client';

import { Return, ShippingLogo, SupportLogo } from 'assets/icons';
import React, { useContext } from 'react';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { M1SelectionContext } from './M1SelectionProvider';
import styles from './Features.module.css';

const features_default = [
  {
    icon: <ShippingLogo />,
    description: 'Free shipping',
  },
  { icon: <Return />, description: 'Hassle-free returns and replacements' },
  { icon: <SupportLogo />, description: '24*7 support' },
];

const features_us = [
  {
    icon: <ShippingLogo />,
    description: 'Delivery in 3-5 days',
  },
  { icon: <Return />, description: 'Hassle-free returns and replacements' },
  { icon: <SupportLogo />, description: '24*7 support' },
];

const features_mcf = [
  {
    icon: <ShippingLogo />,
    description: 'Delivery in 3-5 days',
  },
  { icon: <Return />, description: 'Hassle-free returns and replacements' },
  { icon: <SupportLogo />, description: '24*7 support' },
];

const Feature = ({
  icon,
  description,
}: {
  icon: React.ReactNode;
  description: string;
}) => {
  return (
    <div className={styles.feature}>
      <div className={styles.wrapper}>{icon}</div>
      <p>{description}</p>
    </div>
  );
};

export const Features = () => {
  const { store, mcfDeliveryEstimateState } = useContext(M1SelectionContext);
  let features = features_default;
  if (mcfDeliveryEstimateState || store === ShopifyStore.GB) {
    features = features_mcf;
  } else {
    features = [ShopifyStore.US, ShopifyStore.GB].includes(store)
      ? features_us
      : features_default;
  }
  return (
    <div className={styles.features}>
      {features.map((feature) => (
        <Feature key={feature.description} {...feature} />
      ))}
    </div>
  );
};
